import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Box, Container, Typography, Button, Paper } from "@mui/material"
import { Apple, Android, OpenInNew } from "@mui/icons-material"
import QRCode from "qrcode"

const BathroomDeepLink = () => {
  const { locationId, bathroomId } = useParams()
  const [isMobile, setIsMobile] = useState(false)
  const [qrCodeUrl, setQrCodeUrl] = useState("")

  const deepLink = `crappermapper://bathroom/${locationId}/${bathroomId}`
  const webUrl = `https://tnkl.app/bathroom/${locationId}/${bathroomId}`

  useEffect(() => {
    // Detect if mobile
    const checkMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    setIsMobile(checkMobile)

    // Generate QR code for desktop
    if (!checkMobile) {
      QRCode.toDataURL(webUrl, { width: 200, margin: 2 })
        .then(url => setQrCodeUrl(url))
        .catch(err => console.error("QR code generation error:", err))
    }

    // Auto-redirect on mobile after a short delay
    if (checkMobile) {
      const timer = setTimeout(() => {
        window.location.href = deepLink
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [deepLink, webUrl])

  const handleOpenApp = () => {
    window.location.href = deepLink

    // Fallback to app store if app doesn't open
    setTimeout(() => {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
      const isAndroid = /Android/.test(navigator.userAgent)

      if (isIOS) {
        window.location.href = "https://apps.apple.com/app/id6744712179"
      } else if (isAndroid) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.fvonhoven.crappermapper"
      }
    }, 2000)
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #4A00E0 0%, #8E2DE2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={8}
          sx={{
            padding: 4,
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(135deg, #4A00E0 0%, #8E2DE2 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mb: 1,
              }}
            >
              🚽
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: "#333" }}>
              TNKL
            </Typography>
          </Box>

          {/* Message */}
          <Typography variant="h6" sx={{ mb: 3, color: "#666" }}>
            Open this bathroom in TNKL
          </Typography>

          {/* Open in App Button */}
          {isMobile && (
            <Button
              variant="contained"
              size="large"
              fullWidth
              startIcon={<OpenInNew />}
              onClick={handleOpenApp}
              sx={{
                mb: 3,
                py: 1.5,
                background: "linear-gradient(135deg, #4A00E0 0%, #8E2DE2 100%)",
                fontSize: "1.1rem",
                fontWeight: 600,
                "&:hover": {
                  background: "linear-gradient(135deg, #3A00C0 0%, #7E1DCE 100%)",
                },
              }}
            >
              Open in App
            </Button>
          )}

          {/* QR Code for Desktop */}
          {!isMobile && qrCodeUrl && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
                Scan with your phone to open in the app
              </Typography>
              <img src={qrCodeUrl} alt="QR Code" style={{ maxWidth: "200px" }} />
            </Box>
          )}

          {/* Download Buttons */}
          <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
            {isMobile ? "Don't have the app?" : "Download the app"}
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Button
              variant="outlined"
              size="large"
              fullWidth
              startIcon={<Apple />}
              href="https://apps.apple.com/app/id6744712179"
              target="_blank"
              sx={{
                borderColor: "#4A00E0",
                color: "#4A00E0",
                "&:hover": {
                  borderColor: "#3A00C0",
                  backgroundColor: "rgba(74, 0, 224, 0.04)",
                },
              }}
            >
              Download on App Store
            </Button>

            <Button
              variant="outlined"
              size="large"
              fullWidth
              startIcon={<Android />}
              href="https://play.google.com/store/apps/details?id=com.fvonhoven.crappermapper"
              target="_blank"
              sx={{
                borderColor: "#4A00E0",
                color: "#4A00E0",
                "&:hover": {
                  borderColor: "#3A00C0",
                  backgroundColor: "rgba(74, 0, 224, 0.04)",
                },
              }}
            >
              Get it on Google Play
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default BathroomDeepLink
